import { render } from "./FoldingText.vue?vue&type=template&id=4678ed27&scoped=true"
import script from "./FoldingText.vue?vue&type=script&lang=js"
export * from "./FoldingText.vue?vue&type=script&lang=js"

import "./FoldingText.vue?vue&type=style&index=0&id=4678ed27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4678ed27"]])

export default __exports__